import React, { useState } from 'react';
import { useTranslations } from '../../../../hooks/useTranslations';
import TextLink from '../../../ui/TextLink/TextLink';
import { StoreHourFormatted } from '../../../../../../__generated__/loma';
import {
  useAnalyticsPost,
  NarvarEventTypes,
  NarvarClickTypes,
  NarvarClickSubTypes,
  NarvarEventComponents,
} from '../../../../hooks/Analytics';
import { useTheme } from '../../../../hooks/useTheme';
import styles from './PickupLocationHoursDisclosure.module.css';

export interface PickupLocationHoursDisclosureProps {
  featureName?: string;
  hours?: StoreHourFormatted[] | null;
}

const PickupLocationHoursDisclosure = ({
  featureName,
  hours,
}: PickupLocationHoursDisclosureProps) => {
  const logEvent = useAnalyticsPost();
  const [open, setOpen] = useState(false);

  const { locationHideStoreHours, locationSeeStoreHours } = useTranslations();

  const {
    captiontextDefaultNone,
    linksNoneDefault: linkDefault,
    linksNoneHover: linkHover,
  } = useTheme();

  if (!(hours && hours?.length)) return null;

  return (
    <div className={styles.root}>
      <TextLink
        linkStyle={{ sDefault: linkDefault, sHover: linkHover }}
        onClick={() => {
          setOpen(!open);
          const clickDescription = open
            ? NarvarClickSubTypes.PICKUP_LOCATION_HIDE_HOURS_LINK
            : NarvarClickSubTypes.PICKUP_LOCATION_SHOW_HOURS_LINK;
          logEvent({
            clickCategory: clickDescription,
            clickLinkLabel: open
              ? locationHideStoreHours
              : locationSeeStoreHours,
            clickSubType: clickDescription,
            clickType: NarvarClickTypes.INTERACTION,
            eventComponent: NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
            eventFeature: NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
            eventType: NarvarEventTypes.CLICK,
            feature: featureName,
            pageComponent: NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
          });
        }}
        aria-expanded={open}
        aria-controls="store-hours-list"
      >
        {open ? locationHideStoreHours : locationSeeStoreHours}
      </TextLink>
      {open && (
        <ul
          id="store-hours-list"
          className={styles.hoursList}
          style={captiontextDefaultNone}
        >
          {hours.map((hour) =>
            hour.hoursRange ? (
              <li className={styles.hoursListItem} key={hour.day}>
                <p className={styles.hoursListItemDetail}>{hour.day}</p>
                <p className={styles.hoursListItemDetail}>{hour.hoursRange}</p>
              </li>
            ) : (
              <li className={styles.hoursListItem} key={hour.day}>
                <p className={styles.hoursListItemDetail}>{hour.day}</p>
                <p className={styles.hoursListItemDetail}>CLOSED</p>
              </li>
            ),
          )}
        </ul>
      )}
    </div>
  );
};

export default PickupLocationHoursDisclosure;
